<template>
  <router-view></router-view>
</template>

<script>
// import Main from "./components/Main.vue";
export default {
  name: "App",
  components: {
    // Main,
  },
};
</script>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.buttonClass {
  cursor: pointer;
  border: 2px solid black;
  border-radius: 3px;
  width: 100px;
  margin: 5px;
  font-size: 25px;
}

.orangeHover:hover {
  background: var(--orange);
  color: white;
  border: 2px solid var(--orange);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
  background-image: url(./assets/background.svg);
  background-size: cover;
  width: 100%;
  height: calc(100% - 60px);
  top: 0;
  left: 0px;
  position: absolute;
}

* {
  --orange: #fd7c32;
}
</style>
